import React, { lazy, Suspense } from 'react';
import Loader from 'react-loaders';
import { Redirect, Route, Switch } from 'react-router-dom';

const LoginRoute = lazy(() => import('../../pages/login'));
const RegisterWarrantyRoute = lazy(() => import('../../pages/register-warranty'));

const RoutePublic = () => {
  return (
    <Suspense
      fallback={
        <div className="loader-container">
          <div className="loader-container-inner">
            <div className="text-center">
              <Loader type="ball-grid-cy" />
            </div>
          </div>
        </div>
      }>
      <Switch>
        <Route exact path="/login" component={LoginRoute} />
        <Route exact path="/register-warranty" component={RegisterWarrantyRoute} />
        <Redirect exact from="*" to='/register-warranty' />
      </Switch>
    </Suspense>
  );
};

export default RoutePublic;
